<section class="e_governance_sec innerpage_sec">
  <!-- <div class="elevation_left"></div>
  <div class="photo_overlay_center"></div>
  <div class="photo_overlay_right"></div> -->
  <!-- banner_flower -->
  <!-- <div class="banner_flower sec-padding">
    <img src="../../../../../assets/images/banner-elevation.png" alt="img">
  </div> -->
  <!-- <div class="gov_heading">
    <h2>
      <span> Village virtual offices </span></h2>
  </div> -->
  <div class="custom_heading">
    <h2 class="title">
      Village virtual offices
    </h2>
  </div>
  <div class="e_governance_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
    fxLayout.xs="column" fxLayoutAlign="center center">
    <div class="e_governance_column" fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100"
      fxFlex.xs="100" fxFlexFill>
      <div class="links-section">
        <div class="wrapper">
          <div fxLayout="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
            fxLayoutAlign="center center" fxLayoutGap="8px">
            <div fxLayout="column" fxFlex="100" fxFlexFill>
              <ul *ngIf="selectedLanguage === 'en'; else teluguTemplateVirtualLinks">
                <div class="line_overlay"></div>
                <li class="" *ngFor="let singleLink of villageVirtualOfficeLinksList">
                  <img [src]="singleLink.image.url" alt="" srcset="">
                  <a [href]="singleLink.url" target="_blank" *ngIf="singleLink.type === 'EXTERNAL_URL'">
                    <p>{{singleLink.en_name}} </p>
                  </a>
                </li>
              </ul>
              <ng-template #teluguTemplateVirtualLinks>
                <ul>
                  <div class="line_overlay"></div>
                  <li class="" *ngFor="let singleLink of villageVirtualOfficeLinksList">
                    <img [src]="singleLink.image.url" alt="" srcset="">
                    <a [href]="singleLink.url" target="_blank" *ngIf="singleLink.type === 'EXTERNAL_URL'">
                      <p>{{singleLink.te_name}} </p>
                    </a>
                  </li>
                </ul>
              </ng-template>
              <!--<div class="bottom_link" fxLayout="column" fxLayoutAlign="center center">
                <li class="">
                  <img src="../../../../../assets/images/links/bhim.png" alt="" srcset="">
                  <a href="https://www.telangana.gov.in/" target="_blank">
                    <p>Useful Payment/Recharge APIs</p>
                  </a>
                </li>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <section class="innerpage_bottom_sec">
  <div class="initiatives_top"></div>
</section> -->
